import { Shield, CheckCircle, Users, HeadphonesIcon } from "lucide-react";

const TrustRibbon = () => {
  return (
    <div
      className="w-full border-b border-[hsl(var(--line))] bg-background/80 backdrop-blur-md px-3 py-1.5 md:px-6"
      style={{ boxShadow: "inset 0 -1px 0 hsl(var(--primary) / 0.08)" }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-1.5 min-w-0">
          <Shield className="w-3 h-3 md:w-3.5 md:h-3.5 text-secondary shrink-0" />
          <span className="font-semibold text-foreground text-[10px] md:text-xs tracking-wide truncate">
            Neil AI Global Solutions LLC
          </span>
        </div>

        <div className="flex items-center gap-1 md:gap-1.5">
          <span className="hidden md:inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[hsl(var(--line))] bg-background/40 text-[10px] text-muted-foreground">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(74,222,128,0.6)]" />
            SSL Secured
          </span>
          <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[hsl(var(--line))] bg-background/40 text-[10px] text-muted-foreground">
            <CheckCircle className="w-2.5 h-2.5 text-secondary" />
            Verified Business
          </span>
          <span className="hidden lg:inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[hsl(var(--line))] bg-background/40 text-[10px] text-muted-foreground">
            <Users className="w-2.5 h-2.5 text-secondary" />
            Official Robotics Dealer
          </span>
          <span className="hidden lg:inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[hsl(var(--line))] bg-background/40 text-[10px] text-muted-foreground">
            <HeadphonesIcon className="w-2.5 h-2.5 text-secondary" />
            Human Support & Training
          </span>
        </div>
      </div>
    </div>
  );
};

export default TrustRibbon;
